import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../../../core/services/api.config';
import {
  CreateUserRequest,
  CreateUserResponse,
  GetUserResponse,
  ListPartnersResponse,
  ListUsersResponse,
  ResetUserPasswordRequest,
  ResetUserPasswordResponse,
  UpdateUserProfileRequest,
  UpdateUserProfileResponse,
  UpdateUserStatusRequest,
  UpdateUserStatusResponse,
} from '../models/user.models';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  listUsers(): Observable<ListUsersResponse> {
    return this.http.get<ListUsersResponse>(`${this.apiBaseUrl}/users`, {
      withCredentials: true,
    });
  }

  createUser(payload: CreateUserRequest): Observable<CreateUserResponse> {
    return this.http.post<CreateUserResponse>(`${this.apiBaseUrl}/users`, payload, {
      withCredentials: true,
    });
  }

  getUserById(userId: number): Observable<GetUserResponse> {
    return this.http.get<GetUserResponse>(`${this.apiBaseUrl}/users/${userId}`, {
      withCredentials: true,
    });
  }

  updateUserProfile(
    userId: number,
    payload: UpdateUserProfileRequest,
  ): Observable<UpdateUserProfileResponse> {
    return this.http.patch<UpdateUserProfileResponse>(
      `${this.apiBaseUrl}/users/${userId}/profile`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  updateUserStatus(
    userId: number,
    payload: UpdateUserStatusRequest,
  ): Observable<UpdateUserStatusResponse> {
    return this.http.patch<UpdateUserStatusResponse>(
      `${this.apiBaseUrl}/users/${userId}/status`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  resetUserPassword(
    userId: number,
    payload: ResetUserPasswordRequest,
  ): Observable<ResetUserPasswordResponse> {
    return this.http.post<ResetUserPasswordResponse>(
      `${this.apiBaseUrl}/users/${userId}/reset-password`,
      payload,
      {
        withCredentials: true,
      },
    );
  }

  listPartners(): Observable<ListPartnersResponse> {
    return this.http.get<ListPartnersResponse>(`${this.apiBaseUrl}/partners`, {
      withCredentials: true,
    });
  }
}
